export { default } from './FAQRating'
export * from './FAQRating'
